module.exports = __webpack_public_path__ + "assets/img/logo_insport.5a0e486f.png";